import AnimatedHero from './AnimatedHero'

export default AnimatedHero
